import React, { forwardRef } from "react";
import { Flex } from "../../../primitives/Flex/Flex";
import { FlexColumnBaseProps, FlexColumnComponent } from "./FlexColumn.types";

/**
 * FlexColumn component - A vertical flex layout (flex with direction="column")
 *
 * @example
 * // Basic usage
 * <FlexColumn gap="medium">
 *   <Box>Top content</Box>
 *   <Box>Bottom content</Box>
 * </FlexColumn>
 *
 * // As a sidebar
 * <FlexColumn as="aside" gap="large" justify="space-between">
 *   <Box>Menu items</Box>
 *   <Box>User info</Box>
 * </FlexColumn>
 */

export const FlexColumn = forwardRef(function FlexColumn(
  props: FlexColumnBaseProps & { as?: React.ElementType },
  ref
) {
  const { as, ...rest } = props;

  return (
    <Flex
      ref={ref}
      as={as}
      flexDirection="column"
      alignItems="flex-start"
      width="100%"
      {...(rest as Record<string, unknown>)}
    />
  );
}) as FlexColumnComponent;

// Set display name for debugging
FlexColumn.displayName = "FlexColumn";

export default FlexColumn;
